import React, { FunctionComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from 'components/header/Header.container';
import DashboardLink from 'components/DashboardLink/DashboardLink';
import HelpLeftNavBar from 'components/helpLeftNavBar/HelpLeftNavBar';
import BrowserSettings from './browserSettings/BrowserSettings';
import OSPrivacySettings from './osPrivacySettings/OSPrivacySettings';
import NotificationSettings from './notificationSettings/NotificationSettings';
import Styles from './Help.module.scss';

const Help: FunctionComponent = () => {
  return (
    <div>
      <Header />
      <div className="custom-container">
        <DashboardLink iconClass="fas fa-chevron-left" cssClass="mt-40 mb-45" />
        <div className={Styles.helpWrapper}>
          <div className={Styles.leftSide}>
            <HelpLeftNavBar />
          </div>
          <div className={Styles.rightSide}>
            <Switch>
              <Route exact path="/help/browser-settings">
                <BrowserSettings />
              </Route>
              <Route exact path="/help/os-privacy-settings">
                <OSPrivacySettings />
              </Route>
              <Route exact path="/help/notification-settings">
                <NotificationSettings />
              </Route>
              <Route exact path="/help">
                <BrowserSettings />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;